<template>
	<main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-6">
                        <ul class="breadcrumb">
                            <li><a href="#" title="Home">CNA Box</a></li>
                            <li><a href="#" title="Pages">Gerencial</a></li>
                            <li>Pol�tica Comercial</li>
                        </ul>
                    </section>

                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Criar Nova Regra</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form-create v-if="dialogCreate" @on-saved="onSaved" @on-back="onBack()" />
                    </div>

                </div>
            </div>
        </section>


    </main>

</template>
<script>

    import formCreate from './form-create'

    export default {
        name: 'regrasisencaocertificacoes-create',
        components: { formCreate },
        data: () => ({
            dialogCreate: false,
        }),
        methods: {
            onSaved: function (data) {
                this.$router.push({ path: '/certificacoesregrasisencao/edit/' + data.data.certificacoesRegrasIsencaoId });
            },
            onBack: function () {
                this.$router.go(-1);
            }
        },
		mounted() {
			this.dialogCreate = true;
        }
    };
</script>

